<template>
  <div name="hres80x" class="hres80x">
    <div class="box-tab">
      <div id="accordion">
        <history-heal-illness1 :labels="labels[app.nowLang]"
                               :dataHisHeal="hisHeal" />
        <history-heal-illness2 :labels="labels[app.nowLang]"
                               :dataHisHealDetail="hisHealDetail" />
        <history-heal-family :labels="labels[app.nowLang]"
                             :dataHisHealFamily="hisHealFamily" />
        <history-heal-others :labels="labels[app.nowLang]"
                             :dataHisHeal="hisHeal" />
        <heal-checkup :labels="labels[app.nowLang]"
                      :healCheckupHeader="healCheckupHeader"
                      :healCheckupDetail="healCheckupDetail"
                      :healCheckupRows="healCheckupRows" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as types from 'store/modules/hres80x/mutation-types'
import historyHealIllness1 from 'components/hres80x/historyHealIllness1'
import historyHealIllness2 from 'components/hres80x/historyHealIllness2'
import historyHealFamily from 'components/hres80x/historyHealFamily'
import historyHealOthers from 'components/hres80x/historyHealOthers'
import healCheckup from 'components/hres80x/healthCheckup'

export default {
  name: 'hres80x',
  data () {
    return {
      app: this.$root.$children[0]
    }
  },
  created () {
    this.receivedHres80xColumnsLabels()
    this.receivedHres80xHisHeal(this.app.currentUser.p_codempid)
  },
  computed: {
    ...mapGetters({
      labels: types.GET_HRES80X_LABELS,
      hisHeal: types.GET_HRES80X_HISHEAL,
      hisHealDetail: types.GET_HRES80X_HISHEAL_DETAIL,
      hisHealFamily: types.GET_HRES80X_HISHEAL_FAMILY,
      healCheckupHeader: types.GET_HRES80X_HEAL_CHECKUP_HEADER,
      healCheckupDetail: types.GET_HRES80X_HEAL_CHECKUP_DETAIL,
      healCheckupRows: types.GET_HRES80X_HEAL_CHECKUP_ROWS
    })
  },
  methods: {
    ...mapActions({
      receivedHres80xColumnsLabels: types.RECEIVED_HRES80X_COLUMNS_LABELS,
      receivedHres80xHisHeal: types.RECEIVED_HRES80X_HISHEAL
    })
  },
  components: {
    historyHealIllness1,
    historyHealIllness2,
    historyHealFamily,
    historyHealOthers,
    healCheckup
  }
}

</script>

<style src="./style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// component.vue?49230a2b